import isNilUtil from '../../lang/is-nil'
import omitByObjectUtil from '../omit-by'

/**
 * Returns a copy of the given `object` without `null` or `undefined` values.
 * @param  {Object} obj
 * @param  {Function} [predicate=isNil]
 * @returns {Object}
 */
function compactObjectUtil (obj, predicate = isNilUtil) {
  return omitByObjectUtil(obj, predicate)
}

export {
  compactObjectUtil
}
